import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      isCropping: false,
      cropOptions: [
        {
          name: `${i18n.t("common.custom")} ${i18n.t("files.ratio")}`,
          icon: "ratio",
          altText: "",
          func: () => {
            this.handleSetRatio(NaN);
          },
        },
        {
          name: `1:1 ${i18n.t("common.square")}`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(1);
          },
        },
        {
          name: `4:5 (8:10)`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(4 / 5);
          },
        },
        {
          name: `5:7`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(4 / 5);
          },
        },
        {
          name: `2:3 (4:6)`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(2 / 3);
          },
        },
        {
          name: `16:9`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(16 / 9);
          },
        },
        {
          name: `9:16`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(9 / 16);
          },
        },

        {
          name: `4:3`,
          icon: "ratio",
          altText: "",
          func: (e) => {
            this.handleSetRatio(4 / 3);
          },
        },
      ],
    };
  },
  created() {
    EventBus.$on(`file-editor-preview--reset`, () => {
      this.handleRemoveCrop();
    });
  },
  methods: {
    handleSetRatio(ratio) {
      EventBus.$emit(`file-editor-preview--set-ratio`, ratio);
    },
    handleCropImage() {
      this.isCropping = true;
      EventBus.$emit(`file-editor-preview--create`);
    },
    handleRemoveCrop() {
      this.isCropping = false;
      EventBus.$emit(`file-editor-preview--remove`);
    },
  },
};
